import React from 'react'
import { observer, inject } from 'mobx-react'
import { getMoney } from '@hlj/hlj-utils'
import {
  getCollectIcon,
  getMealPriceColor
} from '@components/LocalMerchant/Decoration/util'

export const CollectorsCount = inject('decorationStore')(
  observer(({ collectors_count, decorationStore: { theme }, style }) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          ...style
        }}
      >
        <img
          style={{ width: 14, height: 14, marginRight: 6 }}
          src={getCollectIcon(theme)}
        />
        <span style={{ height: 14, lineHeight: '16px', fontSize: 12 }}>
          {collectors_count}
        </span>
      </div>
    )
  })
)

export const Price = inject('decorationStore')(
  observer(({ show_price, market_price, decorationStore: { theme } }) => {
    return (
      <>
        {+show_price !== 0 && (
          <span style={{ color: getMealPriceColor(theme), fontSize: 17 }}>
            {getMoney(show_price)}
          </span>
        )}

        {+market_price !== 0 && (
          <span style={{ textDecoration: 'line-through', marginLeft: 5 }}>
            {getMoney(market_price)}
          </span>
        )}
      </>
    )
  })
)
